// Libraries
import React, { useState } from 'react';

// Construct Component
const AdminButton = () => {
  return (
    <>
      <div>Admin</div>
      <a className={`dropdownItem admin`} href="/admin/users">
        Manage Users
      </a>
      <a className={`dropdownItem admin`} href="/admin/subscriptions">
        Manage Subscriptions
      </a>
      <a className={`dropdownItem admin`} href="/admin/features">
        Manage Features
      </a>
      <a className={`dropdownItem admin`} href="/admin/sync-errors">
        Error Review
      </a>
    </>
  );
};

export default AdminButton;
